import { render } from "./instruction.vue?vue&type=template&id=2a25208e&scoped=true"
import script from "./instruction.vue?vue&type=script&lang=js"
export * from "./instruction.vue?vue&type=script&lang=js"

import "./instruction.vue?vue&type=style&index=0&id=2a25208e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a25208e"]])

export default __exports__